import { MessageCircle } from "lucide-react";
import { whatsappUrl } from "@/constants/site";

export const WhatsAppButton = () => {
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={whatsappUrl()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contáctanos por WhatsApp"
      className="fixed bottom-24 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-brand-whatsapp text-white shadow-lg shadow-brand-whatsapp/40 transition-all hover:scale-110 hover:shadow-xl lg:bottom-6 lg:right-6"
    >
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-whatsapp opacity-30" />
      <MessageCircle className="relative h-7 w-7" />
    </a>
  );
};
